import React, { Component } from "react";
import { Row } from "antd";
import { Steps } from "antd";
import "./style.css";

const { Step } = Steps;

class BreadCrumbs extends Component {
  state = {};

  render() {
    const { currentCrumb } = this.props;
    return (
      <div className="breadACrumbsContainer">
        <Row>
          <Steps progressDot current={currentCrumb}>
            <Step title="Job Openings" />

            <Step title="Application Form" />
            <Step title="Applicant Status" />
          </Steps>
        </Row>
      </div>
    );
  }
}

export default BreadCrumbs;
